<template>
  <div>
    <h5>{{ translationHeader }}</h5>
    <a-RenderHTML :value="translationTerminationInstructions" class="mt-4" />
  </div>
</template>

<script>
import Vue from 'vue';
import i18nCommon from '@modules/i18n/mixins/Common';
import RenderHTML from '@modules/design-system/components/atoms/RenderHTML.vue';

export default Vue.extend({
  name: 'TenancyDepositSubscriptionRelease',
  mixins: [i18nCommon],
  components: {
    'a-RenderHTML': RenderHTML,
  },
  computed: {
    translationHeader() {
      return this.translate('tenancyDeposit.release.subscription.header');
    },
    translationTerminationInstructions() {
      return this.translate('tenancyDeposit.md-deposit subscription termination instructions');
    },
  },
});
</script>
